export enum ENVs {
  'production' = 'production',
  'development' = 'development',
}
//

const NAME = 'Brainway';
const ENV =
  process.env.NODE_ENV === 'production' ? ENVs.production : ENVs.development;
const GTM_TAG = process.env.REACT_APP_GTM_TAG || 'GTM-NHVSB53';
const API_TOKEN =
  process.env.REACT_APP_API_TOKEN || '3847c912-c6aa-4ed2-9006-d989e6523ecc';
const BASE_URL =
  process.env.REACT_APP_API_URL ||
  'https://wellness-a-team-effecto-funnel-api-sandbox.cl2.kilo.live/api/';
const SENTRY_DNS = process.env.REACT_APP_SENTRY_DNS || '';
const FIREBASE_REGISTER_URL =
  process.env.REACT_APP_FIREBASE_REGISTER_URL ||
  'https://us-central1-brainway-app-staging.cloudfunctions.net/register';
const REACT_APP_FIREBASE_USER_HAS_PAYED_URL =
  process.env.REACT_APP_FIREBASE_USER_HAS_PAYED_URL ||
  'https://us-central1-brainway-app-staging.cloudfunctions.net/userHasPaid';
const PATIENT_APP_BASE_URL = process.env.REACT_APP_PATIENT_APP_BASE_URL || '';
const HYROS_TOKEN = process.env.REACT_APP_HYROS_TOKEN || '';

const FIREBASE_MAILING =
  process.env.REACT_APP_FIREBASE_MAILING ||
  'https://us-central1-panda-routine-staging.cloudfunctions.net/sendEmail';

const TEMP_BW_KEY =
  process.env.REACT_TEMP_BW_KEY || '3a2f1a1f-5cd3-410a-b30b-7f540e419506';

const CLOUD_FUNCTION_URL = process.env.FIREBASE_CLOUD_FUNCTION_URL;
const TRACKING_ENABLED = true;

const WY_REGISTER_URL =
  process.env.FIREBASE_WY_REGISTER_URL ||
  'https://us-central1-walking-yoga-app-staging.cloudfunctions.net/registerInWeb';

const REACT_APP_FIREBASE_USER_HAS_PAID_URL_WY =
  process.env.REACT_APP_FIREBASE_USER_HAS_PAID_URL_WY ||
  'https://us-central1-walking-yoga-app-staging.cloudfunctions.net/userHasPaid';

const BLOCKED_COUNTRIES = ['LT'];

// TEMP

const configs = {
  [ENVs.development]: {
    ENV,
    NAME,
    GTM_TAG,
    BASE_URL,
    API_TOKEN,
    SENTRY_DNS,
    FIREBASE_REGISTER_URL,
    PATIENT_APP_BASE_URL,
    HYROS_TOKEN,
    REACT_APP_FIREBASE_USER_HAS_PAYED_URL,
    FIREBASE_MAILING,
    TEMP_BW_KEY,
    TRACKING_ENABLED,
    CLOUD_FUNCTION_URL,
    WY_REGISTER_URL,
    REACT_APP_FIREBASE_USER_HAS_PAID_URL_WY,
    BLOCKED_COUNTRIES,
  },
  [ENVs.production]: {
    ENV,
    NAME,
    GTM_TAG,
    BASE_URL,
    API_TOKEN,
    SENTRY_DNS,
    FIREBASE_REGISTER_URL,
    PATIENT_APP_BASE_URL,
    HYROS_TOKEN,
    REACT_APP_FIREBASE_USER_HAS_PAYED_URL,
    FIREBASE_MAILING,
    TEMP_BW_KEY,
    TRACKING_ENABLED,
    CLOUD_FUNCTION_URL,
    WY_REGISTER_URL,
    REACT_APP_FIREBASE_USER_HAS_PAID_URL_WY,
    BLOCKED_COUNTRIES,
  },
};

export const config = configs[ENV];
